// What Explorer opens on before the author touches anything.
//
// An author arriving at Explorer is almost always coming to look at work that
// has finished, and an empty picker asks them to re-state something the data
// already knows. These two rules make that choice; App.js applies them on the
// first load and on every survey switch.

// Newest first, by the timestamp both surveys and deployments carry. Sorted
// here rather than trusted from the wire, and on a copy, so the opening choice
// cannot change because a list arrived in a different order and the caller's
// own list keeps the order its picker renders in.
export const newestFirst = (list = []) => [...list].sort((left, right) => String(right.created_at || '').localeCompare(String(left.created_at || '')));

// The newest survey.
export const pickOpeningSurvey = (list = []) => newestFirst(list)[0]?.id || '';

// The newest CLOSED deployment. A closed deployment has its whole response set
// in hand, which is what there is to explore; an open one is still moving
// underneath the reader. A survey with nothing closed yet falls back to its
// newest deployment, so a survey mid-flight opens somewhere real rather than
// nowhere.
export const pickOpeningDeployment = (list = []) => {
  const ordered = newestFirst(list);
  return (ordered.find(item => item.is_open === false) || ordered[0])?.deployment_id || '';
};
